import { useSelector } from 'react-redux';

import { AppState } from '../store/reducer';

/**
 * A helpful hook for passing a parameter to a memorised selector
 * @param selector - Selector which returns a memorised function
 * @param param - The parameter accpected by the memorised function
 * @returns Result of selector
 */
function useParamSelector<TSelected extends (...args: Array<any>) => ReturnType<TSelected>, TState = AppState>(
  selector: (state: TState) => TSelected,
  // This currently means our types only respect one parameter instead of multiple
  ...params: Parameters<TSelected>
): ReturnType<TSelected> {
  const selectorValueFunction = useSelector(selector);
  // eslint-disable-next-line prefer-spread
  return selectorValueFunction.apply(null, params);
}

export default useParamSelector;
